export default [
  {
    path: '/invoice/list',
    name: 'invoice-list',
    meta: {
      index: 1
    },
    component: () =>
      import(/* webpackChunkName: "invoice-list" */ '@/pages/invoice/list.vue')
  },
  {
    path: '/invoice/list/detail',
    name: 'invoice-detail',
    meta: {
      index: 2
    },
    component: () =>
      import(/* webpackChunkName: "invoice-list" */ '@/pages/invoice/detail.vue')
  }
]
